module.exports = __webpack_public_path__ + "static/media/no-credit-card.cf1a59fa.svg";